"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ADD_PROPERTY_PUBLISH_ATTEMPTED = exports.ONBOARD_COMPLETE_FACT = exports.CUSTOMER_COMPLETENESS_FACT = exports.PROPERTY_COMPLETENESS_FACT = void 0;
exports.PROPERTY_COMPLETENESS_FACT = 'ONBOARD_PROPERTY_COMPLETENESS';
exports.CUSTOMER_COMPLETENESS_FACT = 'ONBOARD_CUSTOMER_COMPLETENESS';
exports.ONBOARD_COMPLETE_FACT = 'ONBOARD_COMPLETE';
exports.ADD_PROPERTY_PUBLISH_ATTEMPTED = 'ADD_PROPERTY_PUBLISH_ATTEMPTED';
//# sourceMappingURL=index.js.map